import React from "react";
import { AlertTriangle, Check, X } from "lucide-react";
import Modal from "./Modal";

export default function ConfirmModal({
  isOpen,
  title = "Onay",
  message,
  confirmText = "Evet",
  cancelText = "Hayır",
  onConfirm,
  onCancel,
  loading = false,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title={title}>
      <div className="confirm-modal-body">
        <div className="confirm-modal-icon">
          <AlertTriangle />
        </div>

        <p className="confirm-modal-text">{message}</p>

        <div className="confirm-modal-actions">
          <button
            type="button"
            onClick={onConfirm}
            className="btn-submit danger"
            disabled={loading}
          >
            <Check />
            {loading ? "İşleniyor..." : confirmText}
          </button>
          <button type="button" onClick={onCancel} className="btn-cancel" disabled={loading}>
            <X />
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
